import type {EventHandler} from '@/redux/middleware/googleTagManager/types';
import type {Action} from 'redux';

type Event = {
  event: 'wishlist';
  event_action: 'hotel_added_to_wishlist_failed';
  giata_id: string;
  non_interaction: false;
};

type EventAction = Action & {
  hotelId: string;
};

export const handler: EventHandler<EventAction, Event> = (action) => {
  return {
    event: 'wishlist',
    event_action: 'hotel_added_to_wishlist_failed',
    giata_id: action.hotelId,
    non_interaction: false,
  };
};
